export enum InputType {
    Text = 'text',
    Password = 'password',
    Area = 'area',
    Date = 'date',
    CreditCard = 'credit-card',
}
